import React, { useEffect } from "react";
import { StudentData } from "../model/StudentData";
import "../pages/dashboard/Dashboard.css";

interface EditStudentModalProps {
  isOpen: boolean;
  student: StudentData | null;
  onClose: () => void;
  onSave: (data: { name: string; resetEmbeddings?: boolean }) => void;
}

const EditStudentModal: React.FC<EditStudentModalProps> = ({
  isOpen,
  student,
  onClose,
  onSave,
}) => {
  const [name, setName] = React.useState(student?.name || "");
  const [resetEmbeddings, setResetEmbeddings] = React.useState(false);

  useEffect(() => {
    setName(student?.name || "");
    setResetEmbeddings(false);
  }, [student]);

  const handleSave = () => {
    if (!name.trim()) return;
    onSave({ name: name.trim(), resetEmbeddings });
    setName("");
    setResetEmbeddings(false);
  };

  if (!isOpen) return null;
  const isCreateMode = !student;

  const embeddingCount = student
    ? [student.embedding1, student.embedding2, student.embedding3].filter(
        (e) => e && e.length > 0,
      ).length
    : 0;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">
            {isCreateMode ? "Thêm học sinh" : "Sửa học sinh"}
          </h2>
          <button onClick={onClose} className="modal-close-button">
            ×
          </button>
        </div>

        <div className="modal-section">
          <div className="modal-field">
            <label className="modal-label">Tên học sinh</label>
            <input
              type="text"
              className="modal-value"
              placeholder="Ví dụ: Nguyễn Văn A"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
            />
          </div>

          {!isCreateMode && (
            <div className="modal-field" style={{ marginTop: 16 }}>
              <label className="modal-label">Face embeddings</label>
              <div style={{ fontSize: 14, color: "#374151", marginBottom: 8 }}>
                Đã có <strong>{embeddingCount}/3</strong> embedding (được set từ
                mobile).
              </div>
              {embeddingCount > 0 && (
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    fontSize: 14,
                    color: "#b91c1c",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={resetEmbeddings}
                    onChange={(e) => setResetEmbeddings(e.target.checked)}
                  />
                  Reset toàn bộ embeddings (mobile sẽ phải scan lại)
                </label>
              )}
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button
            onClick={onClose}
            className="modal-button modal-button-secondary"
          >
            Huỷ
          </button>
          <button
            onClick={handleSave}
            className="modal-button modal-button-primary"
            disabled={!name.trim()}
          >
            {isCreateMode ? "Thêm" : "Lưu"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditStudentModal;
